// extracted by mini-css-extract-plugin
export default {"container":"SearchBar_container__F0JM1","form":"SearchBar_form__ngDTv","kbd":"SearchBar_kbd__NcD6u"};